var map = {
	"./CircleShape/Component": [
		7207,
		207
	],
	"./Group/Component": [
		8159,
		159
	],
	"./LineShape/Component": [
		4655,
		655
	],
	"./Picture/Component": [
		7680,
		680
	],
	"./RectShape/Component": [
		4175,
		175
	],
	"./VButton/Component": [
		8701,
		701
	],
	"./VChart/Component": [
		6329,
		329
	],
	"./VTable/Component": [
		4202,
		202
	],
	"./VText/Component": [
		9464,
		464
	],
	"./svgs/SVGStar/Component": [
		5235,
		235
	],
	"./svgs/SVGTriangle/Component": [
		1386,
		386
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3884;
module.exports = webpackAsyncContext;